export const MESSAGE_BOX = {
  DIALOG: 'message-box-dialog',
  CLOSE_BUTTON: 'message-box-close-button',
  CONTENT: 'message-box-content',
  ACTIONS: 'message-box-actions'
} as const;
